import React, { useEffect, useState } from "react";
import { editIcon } from "../../../Base/SVG";
import Tokens from "./Tokens";
import useWalletConnect from "../../../utils/hooks/useWalletConnect";
import useSignature from "../../../utils/hooks/useSignature";

export default function WalletItem({ form, updateForm, itemData, index }) {
  const [pos, setPos] = useState(itemData);
  const [edit, setEdit] = useState(false);
  const [error, setError] = useState(false);
  const { isConnected } = useWalletConnect();
  const { isSignIn } = useSignature();

  const updatePos = (data) => {
    setPos((pos) => ({ ...pos, ...data }));
  };
  const onChangeInput = (input) => (e) => {
    setPos((pos) => ({ ...pos, [input]: e.target.value }));
  };

  useEffect(() => {
    let arr = [...form.wallets];
    arr[index] = pos;
    updateForm({ wallets: arr });
  }, [pos]);

  useEffect(() => {
    setPos(itemData);
  }, [itemData]);
  const isDisabled = () => {
    if (!isConnected || !isSignIn) {
      return true;
    }
    if (edit) {
      return false;
    }
    return true;
  };
  return (
    <>
      <div className="walletsItem">
        <div className="walletsItem__row">
          <div className="input__outer">
            <label htmlFor="">Your Wallet Address</label>
            <div className="input wIcon">
              <input
                type="text"
                disabled={isDisabled}
                value={pos.address}
                onChange={onChangeInput("address")}
              />
              {/* {error && <p style={{color:'#ff5d5d'}}> Please enter a valid address</p>} */}
              <button
                className="button"
                type="button"
                onClick={() => setEdit(!edit)}
              >
                {editIcon}
              </button>
            </div>
          </div>
          <div className="check">
            <div className="check__row">
              <img src={process.env.PUBLIC_URL + pos.networkIcon} alt="coin" />
              <p className="sw">{pos.network}</p>
            </div>
            <div className="checkInput">
              <input
                disabled={!isConnected || !isSignIn}
                type="checkbox"
                checked={pos.status}
                onChange={(e) => updatePos({ status: e.target.checked })}
              />
              <label htmlFor=""></label>
            </div>
          </div>
        </div>
        <div className="divider"></div>
        <div className="walletsItem__row sb">
          {pos?.coins.map((item, index) => {
            return (
              <Tokens
              isHeadOpen={pos?.status}
                isConnected={isConnected}
                isSignIn={isSignIn}
                pos={pos}
                updatePos={updatePos}
                itemCoinData={item}
                key={index}
                index={index}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
